import { useAtomValue } from 'jotai';
import { Children, type PropsWithChildren } from 'react';
import styled from 'styled-components';

import { Skeleton, SkeletonItem } from '../../atoms';

import { BackgroundViewAtom } from './BackgroundView.atom';

export type MidContentProps = PropsWithChildren<{ disableSkeletons?: boolean; testID?: string }>;

export const MidContent = ({ children, disableSkeletons, testID, ...props }: MidContentProps) => {
	const { isLoading } = useAtomValue(BackgroundViewAtom);

	if (isLoading && !disableSkeletons) {
		return (
			<S.SkeletonWrapper data-testid={testID} {...props}>
				<Skeleton>
					<SkeletonItem height={60} width={120} />
				</Skeleton>
				<Skeleton>
					<SkeletonItem count={Children.count(children) - 1} height={20} width={160} />
				</Skeleton>
			</S.SkeletonWrapper>
		);
	}

	return <S.MidContentWrapper {...props}>{children}</S.MidContentWrapper>;
};

namespace S {
	export const MidContentWrapper = styled.div`
		margin-top: ${({ theme }) => theme.spacings.medium};
		align-items: center;
		display: flex;
		flex-direction: column;
	`;

	export const SkeletonWrapper = styled.div`
		margin-top: ${({ theme }) => theme.spacings.large};
		gap: 15px;
		align-items: center;
		display: flex;
		flex-direction: column;
	`;
}
